import React from 'react';
import WebChat from './components/webchat';

const App = () => {
  const image_src = new URL(
    'images/eli-chat-button.png',
    process.env.ORCHESTRATION_BASE_URL
  ).href;
  return (
    <div>
      <WebChat />
      <button
        type='button'
        className='chatLauncher'
        style={{ display: 'none' }}
      >
        <div>
          <img src={image_src} alt='ELI CHAT BUTTON' />
        </div>
      </button>
    </div>
  );
};

// Wrap the component with the method returned by `withWebChat`.
export default App;
